module.exports = __webpack_public_path__ + "img/Sec_XIV_Evanghelierul_de_la_Rasnov_BAR_676_f3v_e.ec71884e.png";